<template>
  <DashboardTemplate :navMenu="true" class="set-feedback">
    <h2 class="color-primary mg-y-less">แบบประเมินการเรียนออนไลน์</h2>
    <h4 class="mg-y-less pd-b-3">หลักสูตร {{ course.name }}</h4>
    <div class=" pd-b-3">
      <div v-for="(item, index) in assessmentListSort" :key="item._id" class="review-box">
        <div v-if="typeof item.type === 'undefined' || item.type === 1" class="rate-box">
          <FeedbackRate
            :disabled="true"
            :id="item._id"
            :number="`${index + 1}. `"
            :name="item.name"
            :rateDefault="getRate(item._id)"
          />
        </div>
        <div v-else class="text-left comment-box pd-t-4 ">
          <p class="mg-y-less ">{{item.name}}</p>
          <p class="pd-l-4 mg-y-less">{{ getComment(item._id)?getComment(item._id):'-' }}</p>
        </div>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import FeedbackRate from "@/components/feedback/FeedbackRate";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    FeedbackRate,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    assessmentListSort(){
      return this.assessmentList.sort((a,b)=>{
        if(typeof a.type === 'undefined'){return -1}
        if(a.type > b.type){return 1}
        if(a.type < b.type){return -1}
        return 0
      })
    }
  },
  data() {
    return {
      assessment: [],
      assessmentList: [],
      courseId: "",
      userId: "",
      description: "",
      course: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchCouseById();
    this.fetchTakes();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.userId = this.routeParams.userId;
        }
      }
    },
    fetchCouseById() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`course/${this.courseId}`)
        .then((res) => {
          if (res.data.success) {
            this.assessmentList = res.data.obj.assessment;
            this.course = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCouseById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchTakes() {
      this.showVideo = false;
      let obj = {
        courseId: this.courseId,
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/takes`, obj)
        .then((res) => {
 
          if (res.data.success) {
            this.assessment = res.data.obj.assessment[0].assessment;
            this.description = res.data.obj.assessment[0].suggestion;
          }
        })
        .finally(() => {});
    },
    getRate(id) {
      let filter = this.assessment.filter(
        (filter) => filter.assessmentId == id
      );
      if (filter.length > 0) {
        return filter[0].point;
      } else {
        return 0;
      }
    },
    getComment(id) {
  
      let filter = this.assessment.filter(
        (filter) => filter.assessmentId == id
      );

      if (filter.length > 0) {
        return filter[0].comment.toString();
      } else {
        return '';
      }
    },
  },
};
</script>
